import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
export default function BackToTopButton() {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            }
            else {
                setIsVisible(false);
            }
        };
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (<>
      {isVisible && (<button onClick={scrollToTop} className='fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full bg-navy text-white shadow-lg flex items-center justify-center transition-all hover:-translate-y-1 hover:shadow-xl' aria-label='トップへ戻る'>
          <ArrowUp size={20}/>
        </button>)}
    </>);
}
